






















































import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as activity from "../../_store/activity.module";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import { Activities } from "../../_models/activities";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";

@Component({
  components: {
    CardTitle
  }
})
export default class GestionePeriodi extends Vue {
  private titleParams: object;
  private activityState: Activities;

  constructor() {
    super();
    this.titleParams = {
      title: "Gestione Periodi",
      cols: "12",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.activityState = {
      denominazioneIstituto: "",
      idIstituto: 0,
      alternanza: false,
      incontro: false,
      workshop: false,
      colloquio: false,
      tirocinioFormativo: false,
      tirocinioEstivo: false
    };
  }

  confirm() {
    if (confirm("Confermare la modifica dei periodi attività?")) {
      activity
        .dispatchEditInstituteActivityState(this["$store"], this.activityState)
        .then(() => {
          bus.$emit(
            "successfullOperation",
            "Periodi attività modificati con successo"
          );
        })
        .catch(error => {
          if (error.response.status === 401) {
            bus.$emit("errorOperation", error.response.statusText);
            this["$router"].push("/login");
          } else {
            bus.$emit("errorOperation", error.response.statusText);
          }
        });
    }
  }

  created() {
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            bus.$emit("loadMenu");
            var instituteInfo = user.readInstituteInfo(this["$store"]);
            activity
              .dispatchGetInstituteActivityState(
                this["$store"],
                instituteInfo.id
              )
              .then(() => {
                this.activityState = activity.readInstituteActivitiesStatus(
                  this["$store"]
                );
              })
              .catch(error => {
                if (error.response.status === 401) {
                  bus.$emit("errorOperation", error.response.statusText);
                  this["$router"].push("/login");
                } else {
                  bus.$emit("errorOperation", error.response.statusText);
                }
              });
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });
  }
}
